import React, { useContext, useEffect, useState } from 'react';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { useOverview } from '../../../../hooks/overview-hook';
import { useMetricsCriteria } from '../../../../hooks/useMetricsCriteria';
import { FilterContext } from '../../../../components/FilterBar/FilterProvider';
import CardContainer from '../../../../components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from '../../../../components/redesign/KpiGrid';
import KpiTile from 'components/redesign/KpiTile';
import totalUsers from '@v2/kpis/rgm/app/userAdoption/totalUsers';
import activeUsers from '@v2/kpis/rgm/app/userAdoption/activeUsers';
import adoptionRate from '@v2/kpis/rgm/app/userAdoption/adoptionRate';
import averageTimeInPlatform from '@v2/kpis/rgm/app/userAdoption/averageTimeInPlatform';
import uniquePageViews from '@v2/kpis/rgm/app/userAdoption/uniquePageViews';
import uniqueUsers from '@v2/kpis/rgm/app/userAdoption/uniqueUsers';
import { constants } from '../../../../constants/Constants';

interface SummaryMetricsMesLiteProps {
  title?: string;
  setOverviewConfig?: (config: string[]) => void;
  userBehaviorAndEngagementData?: {
    activeUsers: number;
    totalUsers: number;
    adoptionRate: number;
    averageTimeInPlatform: number;
  } | null;
}
const SummaryMetricsMesLite: React.FC<SummaryMetricsMesLiteProps> = ({
  title,
}) => {
  const [overViewConfig, setOverviewConfig] = useState<KpiData[]>([]);
  const {
    userBehaviorAndEngagementData,
    getUserBehaviourAndEngagementData,
    userBehaviorAndEngagementLoading,
  } = useOverview() as any;
  const { operationalMetricCriteria } = useMetricsCriteria();
  const { selectedProduct, selectedPlant, selectedFrequency } =
    useContext(FilterContext);

  useEffect(() => {
    const overviewMetricCriteria = {
      ...operationalMetricCriteria,
      siteId: selectedPlant?.id,
      customerId: null,
      ...(selectedFrequency?.id === 'Weekly' && {
        period: selectedFrequency?.config?.periodDays,
      }),
    };
    getUserBehaviourAndEngagementData({
      variables: { overviewMetricCriteria },
    });
  }, [
    getUserBehaviourAndEngagementData,
    operationalMetricCriteria,
    selectedProduct,
    selectedPlant,
    selectedFrequency,
  ]);

  useEffect(() => {
    if (userBehaviorAndEngagementData) {
      const data = {
        getUserAdoptionScorecard: {
          ...userBehaviorAndEngagementData?.userBehaviour,
        },
      };

      //Override the title for unique users
      const uniqueUsersTile = {
        ...uniqueUsers.handler(data),
        title:
          selectedProduct?.productId === constants.products.MCT
            ? constants.overview.uniqueUsers
            : constants.overview.uniqueSessions,
      };

      // Set the overview configuration with the existing handlers
      const updatedOverviewConfig = [
        totalUsers.handler(data),
        activeUsers.handler(data),
        adoptionRate.handler(data),
        averageTimeInPlatform.handler(data),
        uniquePageViews.handler(data),
        uniqueUsersTile,
      ];

      // Set the updated overview config
      setOverviewConfig(updatedOverviewConfig);
    }
  }, [userBehaviorAndEngagementData, selectedProduct]);

  return (
    <CardContainer
      isLoading={userBehaviorAndEngagementLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]
            ?.userBehaviorAndEngagement?.scoreCard ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid
        columnsDesktop={overViewConfig?.length ? overViewConfig?.length : 3}
        columnsTablet={overViewConfig?.length ? overViewConfig?.length : 3}
        columnsMobile={2}
        showHDividerMobile={false}
      >
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default SummaryMetricsMesLite;
